import PropTypes from 'prop-types';
import MKBox from 'components/MaterialKit/MKBox';
import { useNavigate } from 'react-router-dom';

const Image = ({ src, width, height, alt, borderRadius, objectFit, objectPosition, circle, to, href, ...props }) => {
  const navigate = useNavigate();
  const handleClick = () => {
    if (to) {
      navigate(to);
    } else if (href) {
      window.open(href, '_blank');
    }
  };

  return (
    <MKBox
      component="img"
      src={src}
      width={width || 'auto'}
      height={height || 'auto'}
      loading="lazy"
      alt={alt}
      sx={{
        objectFit,
        objectPosition,
        borderRadius: circle ? '50%' : borderRadius,
        cursor: (to || href) && 'pointer',
      }}
      {...((to || href) && { onClick: handleClick })}
      {...props}
    />
  );
};

Image.propTypes = {
  src: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  alt: PropTypes.string,
  borderRadius: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  objectFit: PropTypes.string,
  objectPosition: PropTypes.string,
  circle: PropTypes.bool,
  to: PropTypes.string,
  href: PropTypes.string,
};

Image.defaultProps = {
  src: null,
  alt: '',
  borderRadius: 0,
  objectFit: 'contain',
  circle: false,
  to: '',
  href: '',
};

export default Image;
